var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "hooper",
    {
      staticStyle: { height: "500px" },
      attrs: { progress: true, autoPlay: true, playSpeed: 3000 },
    },
    [
      _c(
        "slide",
        {
          staticStyle: {
            "background-image": "url('/nc/gfx/hero/hero_slide_1.jpg')",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "hero-slider-container",
              staticStyle: { "margin-top": "" },
            },
            [
              _c("div", { staticClass: "hero-slider-title" }, [
                _vm._v("\n                Nigels Cars\n            "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "hero-slider-text" }, [
                _vm._v(
                  "\n                Affordable Quality Used Cars\n            "
                ),
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn btn-lg btn-primary",
                  attrs: { href: "/showroom" },
                },
                [_vm._v("View Showroom")]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "slide",
        {
          staticStyle: {
            "background-image": "url('/nc/gfx/hero/hero_slide_2.jpg')",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "hero-slider-container",
              staticStyle: { "margin-top": "" },
            },
            [
              _c("div", { staticClass: "hero-slider-title" }, [
                _vm._v("\n                Nigels Cars\n            "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "hero-slider-text" }, [
                _vm._v(
                  "\n                Warranty & MOT with all cars\n            "
                ),
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn btn-lg btn-primary",
                  attrs: { href: "/showroom" },
                },
                [_vm._v("View Showroom")]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "slide",
        {
          staticStyle: {
            "background-image": "url('/nc/gfx/hero/hero_slide_3.jpg')",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "hero-slider-container",
              staticStyle: { "margin-top": "" },
            },
            [
              _c("div", { staticClass: "hero-slider-title" }, [
                _vm._v("\n                Nigels Cars\n            "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "hero-slider-text" }, [
                _vm._v("\n                Finanace Available\n            "),
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn btn-lg btn-primary",
                  attrs: { href: "/showroom" },
                },
                [_vm._v("View Showroom")]
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }